import styled from 'styled-components'
import { Modal } from 'antd'

export const ModalWrapper = styled(Modal)`
  .footer {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.5rem;
  }
`
